import React from 'react';
import type { ANNOTATION_SHAPE_STYLING_TYPE } from '../../constants';
import { ANNOTATION_TYPE } from '../../constants';
import { type AnnotationT } from '../../types';
import Ellipse from '../annotations/ellipse/ellipse';
import KeyPoint from '../annotations/key-point/key-point';
import Polygon from '../annotations/polygon/polygon';
import Polyline from '../annotations/polyline/polyline';
import Rectangle from '../annotations/rectangle/rectangle';
import SegmentationAnnotation from '../annotations/segmentation/segmentation-annotation';
import Cuboid from './cuboid/cuboid';
import { Skeleton } from './skeleton/skeleton';
type PropsT = {
  annotation: AnnotationT;
  annotationIdx: string;
  disableChanges?: boolean;
  stylingType?: (typeof ANNOTATION_SHAPE_STYLING_TYPE)[keyof typeof ANNOTATION_SHAPE_STYLING_TYPE];
  isFocusModeEnabled?: boolean;
  selectedAnnotationIds?: string[];
};
const Annotation = ({
  annotation,
  annotationIdx,
  disableChanges,
  stylingType,
  isFocusModeEnabled,
  selectedAnnotationIds = []
}: PropsT) => {
  if (isFocusModeEnabled && !selectedAnnotationIds.includes(annotationIdx)) return null;
  switch (annotation.annotationType) {
    case ANNOTATION_TYPE.RECTANGLE:
      return <Rectangle annotationIdx={annotationIdx} annotation={annotation} disableChanges={disableChanges} stylingType={stylingType} />;
    case ANNOTATION_TYPE.CUBOID:
      return <Cuboid annotationIdx={annotationIdx} annotation={annotation} disableChanges={disableChanges} stylingType={stylingType} />;
    case ANNOTATION_TYPE.ELLIPSE:
      return <Ellipse annotationIdx={annotationIdx} annotation={annotation} disableChanges={disableChanges} stylingType={stylingType} />;
    case ANNOTATION_TYPE.POLYGON:
      return <Polygon annotationIdx={annotationIdx} annotation={annotation} disableChanges={disableChanges} stylingType={stylingType} />;
    case ANNOTATION_TYPE.KEY_POINT:
      return <KeyPoint annotationIdx={annotationIdx} annotation={annotation} disableChanges={disableChanges} />;
    case ANNOTATION_TYPE.POLYLINE:
      return <Polyline annotationIdx={annotationIdx} annotation={annotation} disableChanges={disableChanges} stylingType={stylingType} />;
    case ANNOTATION_TYPE.SEGMENTATION:
      return <SegmentationAnnotation annotationIdx={annotationIdx} annotation={annotation} />;
    case ANNOTATION_TYPE.SKELETON:
      return <Skeleton annotationIdx={annotationIdx} annotation={annotation} disableChanges={disableChanges} />;
  }
  return null;
};
export default Annotation;